import Axios from 'axios';
import moment from 'moment';
import {baseUrl, redirect_URL, requestHeader} from '../../config';
import {getRegistrarPayload} from '../../types/lead.actions.types';
import {checkAppraisalRouter, handleToast, updateRegistrarDetail, userInterested} from '../../utils/handler';
import store from '../store';
import {CatchReturnError} from './actionHandler';
import * as types from './types';
// requestHeader.Authorization = localStorage.getItem('saw-token') || ""

export const downloadEbook = (leadUID: string) => {
  return Axios.get(baseUrl + '/downloadEbook/' + leadUID, requestHeader)
    .then((res) => {
      let response = res['data'];
      return response;
    })
    .catch((err) => {
      return CatchReturnError(err);
    });
};

export const checkBlockedCountry = () => {
  return Axios.get(baseUrl + '/checkBlockedCountry').catch((err) => {
    return CatchReturnError(err);
  });
};
export const updateClicks = (registrarUID: string, dn: string | null) => {
  return Axios.post(baseUrl + '/updateClicks/' + registrarUID + `?dn=${dn}`, {domainName: dn}, requestHeader)
    .then((res) => {
      if (res.status === 203) {
        store.dispatch({type: types.LOCATION_NOT_SUPPORT, payload: true});
      }
      let response = res['data'];
      if (response) {
        updateRegistrarDetail(response);
      }
      return res.status;
    })
    .catch((err) => {
      updateRegistrarDetail();
      // return CatchReturnError(err)
    });
};

export const registrarDetails = (UID: string, dn: string | null) => {
  return Axios.get(baseUrl + '/registrarDetails/' + UID + `?domainName=${dn}`, requestHeader)
    .then((res) => {
      let response = res['data'];
      if (response) {
        updateRegistrarDetail(response);
      }
    })
    .catch((err) => {
      return CatchReturnError(err);
    });
};

export const createOrUpdateOpportunities = (payload: any) => {
  let interestIn = localStorage.getItem('interestIn') || userInterested.buy;
  payload.interestIn = interestIn;
  return Axios.post(baseUrl + '/createOrUpdateOpportunities', payload, requestHeader)
    .then((res) => {
      localStorage.removeItem('interestIn');
      // let response = res['data']
      return res;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const createLeadAction = (payload: any) => {
  // const { registrarDetails } = store.getState().userReducer;
  // if (registrarDetails && registrarDetails.UID) {
  //   payload.registrarUID = registrarDetails.UID;
  // }
  let referrerURL = document.referrer
  if (referrerURL && referrerURL.includes(redirect_URL)) {
    referrerURL = ""
  }
  if (referrerURL) payload.referrerURL = referrerURL
  if (payload.offerAmount) payload.offerAmount = payload.offerAmount.toString();
  if (!payload.formName) payload.formName = checkAppraisalRouter() ? "Appraisal Buy" : "";

  return Axios.post(baseUrl + '/leads', payload, requestHeader)
    .then((res) => {
      // updateRegistrarDetail();
      return res;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};
export const updateLead = (leadUID: string, payload: any) => {
  return Axios.patch(baseUrl + '/leads/' + leadUID, payload, requestHeader)
    .then((res) => {
      let response = res['data'];
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getMyLeads = () => {
  return Axios.get(baseUrl + '/getMyLeads', requestHeader)
    .then((res) => {
      let response = res['data'];
      store.dispatch({type: types.GET_MY_LEADS, payload: response});
      return response;
    })
    .catch((err) => {
      CatchReturnError(err);
    });
};

export const getRegistrarLeads = (payload: getRegistrarPayload) => {
  let {pageNumber = 1, limit = 10, dateFilter, sortBy = 'Date', sortType = 'DESC', registrarUID = '', consolidateDashboard = false} = {...payload};
  let query = `/getRegistrarLeads?pageNumber=${pageNumber}&limit=${limit}&sortBy=${sortBy}&sortType=${sortType}&registrarUID=${registrarUID}&consolidateDashboard=${consolidateDashboard}`;
  if (dateFilter) {
    if (moment(dateFilter.fromDate).isValid()) {
      query = query + `&fromDate=${moment(dateFilter.fromDate).format('YYYY-MM-DD 00:00:00')}`;
    }
    if (moment(dateFilter.toDate).isValid()) {
      query = query + `&toDate=${moment(dateFilter.toDate).add(1, 'days').format('YYYY-MM-DD 00:00:00')}`;
    }
  }

  return Axios.get(baseUrl + query, requestHeader)
    .then((res) => {
      let response = res['data'];
      store.dispatch({type: types.GET_REGISTRAR_LEADS, payload: response});
      return response;
    })
    .catch((err) => {
      handleToast(err);
      CatchReturnError(err);
    });
};

// export const getPaymentReconcileCSV = async (payload) => {
//   const { source = 'all', status = 'all' } = payload;
//   const path = '/getPaymentDataCSV';
//   const query = new URLSearchParams({ source, status });

//   return Axios.get(baseUrl + path + `?${query.toString()}`, requestHeader)
//     .then((res) => {
//       if (res.data?.csv) {
//         let csvFile, downloadLink;
//         csvFile = new Blob([res.data?.csv], { type: 'text/csv' });
//         downloadLink = document.createElement('a');
//         downloadLink.download = res.data?.fileName;
//         downloadLink.href = window.URL.createObjectURL(csvFile);
//         downloadLink.style.display = 'none';

//         document.body.appendChild(downloadLink);
//         downloadLink.click();
//       } else if (res.data?.data) {
//         handleToast({ message: res.data?.data }, 'success');
//       }
//     })
//     .catch((err) => {
//       handleToast(err);
//       CatchReturnError(err);
//     });
// };

interface registrarSettleDashPayload {
  startDate: Date;
  endDate: Date;
}

export const getTransactionReconcileCSV = async (payload: registrarSettleDashPayload) => {
  const {startDate, endDate} = payload;
  const start = moment(startDate).format('yyyy-MM-DD');
  const end = moment(endDate).format('yyyy-MM-DD');
  const path = '/getTransactionDataCSV';
  const query = new URLSearchParams({startDate: start, endDate: end});

  return Axios.get(baseUrl + path + `?${query.toString()}`, requestHeader)
    .then((res) => {
      if (res.data?.csv) {
        let csvFile, downloadLink;
        csvFile = new Blob([res.data?.csv], {type: 'text/csv'});
        downloadLink = document.createElement('a');
        downloadLink.download = res.data?.fileName;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = 'none';

        document.body.appendChild(downloadLink);
        downloadLink.click();
      } else if (res.data?.data) {
        handleToast({message: res.data?.data}, 'success');
      }
    })
    .catch((err) => {
      handleToast(err);
      CatchReturnError(err);
    });
};

export const getRegistrarSettleDashData = async (payload: registrarSettleDashPayload) => {
  const {startDate, endDate} = payload;
  const start = moment(startDate).format('yyyy-MM-DD');
  const end = moment(endDate).format('yyyy-MM-DD');
  const path = '/getRegistrarSettleSummary';
  const query = new URLSearchParams({startDate: start, endDate: end});

  return Axios.get(baseUrl + path + `?${query.toString()}`, requestHeader);
};
